import { oc } from "@orpc/contract";
import { z } from "zod";

// ============================================================================
// Update Rebate Invoice - Update invoice number for a rebate invoice
// ============================================================================

export const UpdateRebateInvoiceRequestSchema = z.object({
  invoiceId: z.string().uuid("Invalid invoice ID format"),
  invoiceNumber: z.string().nullable(),
});

export const UpdateRebateInvoiceResponseSchema = z.object({
  data: z.object({
    id: z.string().uuid(),
    invoiceNumber: z.string().nullable(),
  }),
});

// ============================================================================
// Contract Definitions
// ============================================================================

export const rebateInvoicesContracts = {
  update: oc
    .input(UpdateRebateInvoiceRequestSchema)
    .output(UpdateRebateInvoiceResponseSchema)
    .route({ method: "POST" }),
} as const;

// ============================================================================
// Type Exports
// ============================================================================

export type UpdateRebateInvoiceRequest = z.infer<
  typeof UpdateRebateInvoiceRequestSchema
>;
export type UpdateRebateInvoiceResponse = z.infer<
  typeof UpdateRebateInvoiceResponseSchema
>;
